import React from "react";
import { DataGridPagination, useDataGrid } from "..";
import { RowData, Table, PaginationState } from "@tanstack/react-table";

const DataGridToolbar = () => {
  const { table, props } = useDataGrid();
  const typedTable = table as Table<RowData>;

  // Handle page size change with support for both internal and external pagination
  const handlePageSizeChange = (newSize: number) => {
    if (props.pagination?.setPagination) {
      // Use the parent component's setPagination function for server-side pagination
      props.pagination.setPagination((prev: PaginationState) => ({
        ...prev,
        pageSize: newSize,
        pageIndex: 0, // Reset to first page when changing page size
      }));
    } else {
      // Use the table's built-in pagination for client-side pagination
      typedTable.setPageSize(newSize);
    }
  };

  return (
    <div className="card-footer justify-center md:justify-between flex-col md:flex-row gap-3 text-gray-600 text-2sm font-medium">
      <div className="flex items-center gap-2">
        <span id="dg-sizes-label">{props.pagination?.sizesLabel}</span>
        <select
          className="select select-sm w-16"
          value={table.getState().pagination.pageSize}
          aria-labelledby="dg-sizes-label dg-sizes-desc"
          onChange={(e) => {
            handlePageSizeChange(Number(e.target.value));
          }}
          aria-label={props.pagination?.sizesLabel ?? "Rows per page"}
        >
          {props.pagination?.sizes?.map((size, index) => (
            <option key={index} value={size}>
              {size}
            </option>
          ))}
        </select>{" "}
        <span id="dg-sizes-desc">{props.pagination?.sizesDescription}</span>
      </div>
      <DataGridPagination />
    </div>
  );
};

export { DataGridToolbar };
